module.exports = __webpack_public_path__ + "img/1481086797.c85847d4.jpg";